import React from 'react'
import Box from '@mui/material/Box'
import {reExportedColors} from '../../1elements'

const TableBodyCell = ({children, display, gridColumn, className, fontSize}) => {
    return(
        <Box
            className={className}
            sx={{
                alignSelf: 'center',
                color: reExportedColors.TEXT,
                display,
                fontFamily: 'Roboto, sans-serif',
                fontSize: fontSize || '13px',
                gridColumn,
                overflow: 'hidden',
                padding: '0 24px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }}
        >
            {children}
        </Box>
    )
}

export default TableBodyCell
